import './index.scss'

import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('button')

const Button = forwardRef(
  (
    {
      children,
      primary,
      secondary,
      success,
      large,
      small,
      xsmall,
      dark,
      disabled,
      type,
      block,
      square,
      to,
      outline,
      subtle,
      close,
      mailto,
      className,
      arrow,
      circle,
      circular,
      link,
      ...props
    },
    ref
  ) => {
    const showArrow = arrow || (to && arrow !== false)
    const modifiers = {
      primary,
      secondary,
      success,
      dark,
      large,
      small,
      xsmall,
      close,
      block,
      outline,
      circle,
      circular,
      link,
      subtle,
      disabled,
      square,
      empty: !children,
      arrow: showArrow,
    }

    if (to) {
      return (
        <Link to={to} {...bem('', modifiers, className)} {...props}>
          {circle && <span {...bem('circle')}>{circle}</span>}
          <span {...bem('label')}>{children}</span>
        </Link>
      )
    }

    return (
      <button type={type} {...bem('', modifiers, className)} {...props}>
        {circle && <span {...bem('circle')}>{circle}</span>}
        <span {...bem('label')}>{children}</span>
      </button>
    )
  }
)

Button.propTypes = {
  children: PropTypes.any,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  success: PropTypes.bool,
  outline: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool,
  xsmall: PropTypes.bool,
  arrow: PropTypes.bool,
  type: PropTypes.string,
  to: PropTypes.string,
  circle: PropTypes.node,
  close: PropTypes.bool,
  circular: PropTypes.bool,
  square: PropTypes.bool,
  disabled: PropTypes.bool,
  subtle: PropTypes.bool,
  mailto: PropTypes.string,
  className: PropTypes.string,
}

Button.defaultProps = {
  type: 'button',
}

export default Button
